import {PlaceActionTypes} from "./types";

const INITIAL_STATE = {
  places: undefined,
};

const placesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PlaceActionTypes.SET_PLACES:
      return {
        ...state,
        places: action.payload,
      };
    default:
      return state;
  }
};

export default placesReducer;